import script from "./ServiceCaroussel.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceCaroussel.vue?vue&type=script&setup=true&lang=js"

import "./ServiceCaroussel.vue?vue&type=style&index=0&id=0445e5a6&lang=css"

const __exports__ = script;

export default __exports__